import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useHardinessZones } from "@/hooks/useHardinessZones";

interface HardinessZoneSelectorProps {
  value?: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  showLabel?: boolean;
}

export const HardinessZoneSelector = ({ 
  value, 
  onValueChange, 
  placeholder = "Select your hardiness zone",
  showLabel = true
}: HardinessZoneSelectorProps) => {
  const { zonesBySystem, loading } = useHardinessZones();

  if (loading) {
    return (
      <div className={showLabel ? "space-y-2" : ""}>
        {showLabel && <Label htmlFor="hardiness-zone">Hardiness Zone</Label>}
        <Select disabled>
          <SelectTrigger>
            <SelectValue placeholder="Loading zones..." />
          </SelectTrigger>
        </Select>
      </div>
    );
  }

  return (
    <div className={showLabel ? "space-y-2" : ""}>
      {showLabel && <Label htmlFor="hardiness-zone">Hardiness Zone</Label>}
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger className="h-8 text-sm">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent className="max-h-[200px] z-50 bg-white">
          {Object.entries(zonesBySystem).map(([system, zones]) => (
            <div key={system}>
              <div className="px-2 py-1 text-xs font-semibold text-muted-foreground">
                {system} Zones
              </div>
              {zones.map((zone) => (
                <SelectItem key={zone.id} value={zone.id} className="text-sm">
                  <div className="flex items-center gap-2">
                    <span className="font-medium">{zone.zone_code}</span>
                    <span className="text-xs text-muted-foreground truncate">
                      {zone.zone_name}
                    </span>
                  </div>
                </SelectItem>
              ))}
            </div>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};